/**
 * @module
 * @author Jacob Viertel <jv@onscreen.net>
 */
import {defineRegistryElement, defineRenderElement} from '@acng/frontend-stargazer';
import {ObserveAttributes} from '@acng/frontend-bounty/dom/observe.js';

import {toggle} from '../service/anchor-active.js';
import {ANCHOR} from '@acng/frontend-bounty/dom/element.js';
import {HREF} from '@acng/frontend-bounty/dom/attribute.js';

/**
 * Enable styles according to the current browser location.
 *
 * A {@link !HTMLAnchorElement} will become `layout-active` if it lead to the current location.
 * It will become `layout-inactive` otherwhise.
 *
 * A {@link !HTMLDetailsElement} will become `layout-active` if the subtree contains an `a.layout-active`.
 * It will become `layout-inactive` otherwhise.
 *
 * @example
 * ```html
 * <nav>
 *   <a href="/">Home</a>
 *   <a href="/settings.html">Settings</a>
 *   <details>
 *     <summary>Special</summary>
 *     <a href="/special/a.html">A</a>
 *     <a href="/special/b.html">B</a>
 *     <a href="/special/c.html">C</a>
 *   </details>
 * </nav>
 * ```
 * @since 3.83.0
 */
export const ANCHOR_ACTIVE = ANCHOR;

defineRegistryElement(ANCHOR, (name) => {
  const connectFn = ObserveAttributes([HREF], toggle, true);

  defineRenderElement(name, () => connectFn);
});
